import classNames from 'classnames';
import { XL } from 'constants/breakpoints';
import React from 'react'
import useMediaQuery from 'utils/hooks/useMediaQuery';

const DesktopProgress = ({ isActive, isLastStep }) => {
  const isMobile = useMediaQuery(XL);

  return (
    !isMobile && !isLastStep && (
      <div className="position-relative">
        <div className={classNames({
          "below_divider": true,
          "step-active": isActive,
        })}></div>
      </div>
    )
  )
}

export default DesktopProgress;